// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '21720aa47e8c217ee7a453a6f80a1353746e9be3';
export const BUILD_NUMBER = '220';
export const BUILD_TIMESTAMP = '2026-08-24T01:19:45.131Z';
